<style scoped>
	.imgUpload{
		position: relative;
		border:1px dashed #08a;
		border-radius: 3px;
		text-align: center;
	}
	.imgUpload img{
		max-width: 100%;
	}
	.file-layout{
		position: absolute;
		top:0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	.file-layout input {
		width: 100%;
		height: 100%;
		opacity: 0;
	}
	p{
		margin: 0;
		font-size: 12px;
		color: #a7a7a7;
		padding: 8px 0;
	}

</style>
<template>
	<div class="imgUpload">
		<img class="imgsize" :src="img" alt="" v-show="img.length > 0">
		<p v-else>{{tips}}</p>
		<div class="file-layout"><input type="file" id="{{fileID}}"></div>
	</div>
</template>
<script>
	var ImgObj = require('../utils/ImgHelper.js');
	var initTips = '点击选择图片';//初始的文字提示
	module.exports = {
		props : ['image'],//由外部传入
		data : function(){
			return {
				fileID : '',
				img : '',
				tips : initTips
			}
		},
		created : function(){			
			//初始设置ID的值，避免重复
			this.fileID = 'file-' + new Date().getTime() + '-' + Math.floor(Math.random(1,10) * 10);
			if(this.image != undefined){
				this.img = this.image;
			}
		},
		ready : function(){
			var self = this;
			var file = document.getElementById(this.fileID);
			ImgObj.bindImgChange(file,function(rs){
				self.tips = rs.content;
			},function(rs){
				if(rs.status == 'succ'){
					self.tips = initTips;
					self.img = rs.content;
				}else{
					self.tips = rs.content;
				}
			});
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Imgupload.vue?6d435335
 **/